import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "home": "Home",
      "about": "About",
      "services": "Services",
      "resume": "Resume",
      "portfolio": "Portfolio",
      "blog": "Blog",
      "contact": "Contact",
      "settings": "Settings",
      "dark_mode": "Dark Mode",
      "language": "Language",
      "extra_option": "Extra Option",
      "current_language": "Current language: {{language}}",
      "scroll_down": "Scroll Down",
      "contact_me": "Contact Me",
      "hello": "I'm Bram! A driven IT student with a passion for networking, DevOps, and cybersecurity.",
      "about_me": "About Me",
      "experience": "Experience",
      "recent_works": "Recent Works",
      "name": "Name",
      "email": "Email",
      "message": "Message",
      "send_message": "Send message",
      "download_cv": "Download CV",
      "security": "Security",
      "cloud_engineering": "Cloud Engineering",
      "network_engineering": "Network Engineering",
      "job_title": "Job Title",
      "company_name": "Company Name",
      "job_description": "Job Description",
      "project_title": "Project Title",
      "project_description": "Project Description",
      "about_description": "I am Bram Platier, a passionate Network Engineer from Eindhoven, Netherlands. With expertise in cybersecurity, cloud solutions, and network infrastructure, I love turning complex technical challenges into elegant solutions. Currently focused on DevOps practices and cloud-native technologies to build robust, scalable systems.",
      "contact_details": "Don't like forms? Send me an email. 👋",
      "message_sent": "Your message has been sent!",
      "everything": "Everything",
      "view_project": "View Project",
      "websites": "Websites",
      "cloud": "Cloud",
      "devops": "DevOps",
      "automation": "Automation",
  "containerization": "Containerization",
      "games": "Games",
      "web_and_games": "Web & Games",
      "web_and_apps": "Web & Apps",
      "web_and_esports": "Web & Esports",
      "devops_and_automation": "DevOps & Automation",
      "cloud_and_security": "Cloud & Security",
      "servers_not_on_fire": "Servers Not On Fire",
      "cups_of_tea": "1,000+ Cups of tea Consumed",
      "happy_clients": "42 Happy Clients",
      "awards_won": "0 Awards Won :(",
      "it_intern": "IT Intern",
      "i_level_ict_solutions": "i-LEVEL ICT Solutions, Veldhoven - Implementation and maintenance of network infrastructure, focused on security improvements and cloud solutions.",
      "zit_intern": "ZIT Intern",
      "maxima_medical_center": "Máxima Medisch Centrum, Veldhoven - Healthcare IT and network infrastructure management.",
      "delivery_driver": "Delivery Driver",
      "dominos": "Domino's, Eindhoven - Part-time work alongside studies",
      "newspaper_delivery": "Newspaper Delivery",
      "groot_eindhoven": "Groot Eindhoven - First work experience",
      "services.title": "What I Do",
      "services.cybersecurity.title": "Cybersecurity",
      "services.cybersecurity.description": "Implementation and management of security measures to protect systems, networks, and data.",
      "exp1_title": "Sales Employee",
      "exp1_company": "IKEA",
      "exp1_period": "Jul 2025 - Present",
      "exp1_desc": "Customer service and sales support",
      "exp2_title": "Automation Intern",
      "exp2_company": "Van Boxtel",
      "exp2_period": "Sep 2024 - Jan 2026",
      "exp2_desc": "Automation project internship focusing on system optimization and process automation",
      "exp3_title": "IT Intern",
      "exp3_company": "i-LEVEL ICT Solutions, Veldhoven",
      "exp3_period": "2022 - 2023",
      "exp3_desc": "Implementation and maintenance of network infrastructure, focused on security improvements and cloud solutions",
      "exp4_title": "ZIT Intern",
      "exp4_company": "Máxima Medisch Centrum, Veldhoven",
      "exp4_period": "2021 - 2022",
      "exp4_desc": "Healthcare IT and network infrastructure management",
      "exp5_title": "Delivery Driver",
      "exp5_company": "Domino's, Eindhoven",
      "exp5_period": "2022 - 2023",
      "exp5_desc": "Part-time work alongside studies",
      "exp6_title": "Newspaper Delivery",
      "exp6_company": "Groot Eindhoven",
      "exp6_period": "2014 - 2016",
      "exp6_desc": "First work experience",
      "services.security.title": "Security",
      "services.security.description": "Implementation of security measures to protect systems and data. Proactive monitoring and incident response.",
      "services.network_engineering.title": "Network Engineering",
      "services.network_engineering.description": "Design, implementation, and management of complex network infrastructures. Focus on reliability and performance.",
      "pricing.title": "My Pricing",
      "pricing.get_started": "Get Started",
      "pricing.basic.title": "Basic",
      "pricing.basic.price": "€25/hour",
      "pricing.basic.feature1": "Network troubleshooting",
      "pricing.basic.feature2": "Basic security audit",
      "pricing.basic.feature3": "Cloud consultation",
      "pricing.premium.title": "Premium",
      "pricing.premium.price": "€40/hour",
      "pricing.premium.feature1": "Advanced network design",
      "pricing.premium.feature2": "Comprehensive security implementation",
      "pricing.premium.feature3": "Cloud migration and management",
      "pricing.ultimate.title": "Ultimate",
      "pricing.ultimate.price": "€60/hour",
      "pricing.ultimate.feature1": "Full network and security management",
      "pricing.ultimate.feature2": "DevOps and automation solutions",
      "pricing.ultimate.feature3": "24/7 support",
      "Feedback": "Feedback",
      "leave_feedback": "Leave your feedback",
      "submit": "Submit",
      "feedback_submitted_successfully": "Thank you for your feedback!",
      "error_submitting_feedback": "Error submitting feedback. Please try again.",
      "This feature is currently under development": "This feature is currently under development",
      "experience_title": "Experience",
      "experience_subtitle": "Check out my professional journey on",
      "view_profile": "View My Profile",
      "experience_description": "Click the LinkedIn link to see my complete professional experience, skills, and recommendations.",
      "visit_linkedin": "View Full Profile on LinkedIn",
      "education": "Education",
      "work_experience": "Work Experience",
      "testimonials_title": "Client Testimonials",
      "blog_title": "Latest Articles",
      "skills_title": "Skills & Expertise",
      "tech_stack_title": "Tech Stack",
      "certificates_title": "Diplomas & Certifications",
      "footer_title": "Let's Work Together",
      "footer_subtitle": "Have a project or question? Feel free to reach out!",
      "quick_links": "Quick Links",
      "social_media": "Social Media",
      "start_project": "Start a Project",
      "all_rights_reserved": "All rights reserved."
    }
  },
  nl: {
    translation: {
      "home": "Home",
      "about": "Over",
      "services": "Diensten",
      "resume": "CV",
      "portfolio": "Portfolio",
      "blog": "Blog",
      "contact": "Contact",
      "settings": "Instellingen",
      "dark_mode": "Donkere modus",
      "language": "Taal",
      "extra_option": "Extra optie",
      "current_language": "Huidige taal: {{language}}",
      "scroll_down": "Scroll naar beneden",
      "contact_me": "Neem contact op",
      "hello": "ik ben Bram! Een gedreven IT-student met een passie voor netwerken, DevOps en cybersecurity.",
      "about_me": "Over Mij",
      "experience": "Ervaring",
      "recent_works": "Recente Werken",
      "name": "Naam",
      "email": "E-mail",
      "message": "Bericht",
      "send_message": "Verstuur bericht",
      "download_cv": "Download CV",
      "security": "Beveiliging",
      "cloud_engineering": "Cloud Engineering",
      "network_engineering": "Netwerk Engineering",
      "job_title": "Functietitel",
      "company_name": "Bedrijfsnaam",
      "job_description": "Functieomschrijving",
      "project_title": "Projecttitel",
      "project_description": "Projectbeschrijving",
      "about_description": "Ik ben Bram Platier, een gepassioneerde netwerkingenieur uit Eindhoven, Nederland. Met expertise in cybersecurity, cloudoplossingen en netwerkinfrastructuur, hou ik ervan om complexe technische uitdagingen om te zetten in elegante oplossingen. Momenteel richt ik me op DevOps-praktijken en cloud-native technologieën om robuuste, schaalbare systemen te bouwen.",
      "contact_details": "Hou je niet van formulieren? Stuur me een e-mail. 👋",
      "message_sent": "Je bericht is verzonden!",
      "everything": "Alles",
      "view_project": "Bekijk project",
      "websites": "Websites",
      "cloud": "Cloud",
      "devops": "DevOps",
      "automation": "Automatisering",
  "containerization": "Containerisatie",
      "games": "Games",
      "web_and_games": "Web & Games",
      "web_and_apps": "Web & Apps",
      "web_and_esports": "Web & Esports",
      "devops_and_automation": "DevOps & Automatisering",
      "cloud_and_security": "Cloud & Security",
      "servers_not_on_fire": "Servers Niet In Brand",
      "cups_of_tea": "1.000+ Kopjes thee Geconsumeerd",
      "happy_clients": "42 Tevreden Klanten",
      "awards_won": "0 Prijzen Gewonnen :(",
      "it_intern": "IT Stagiair",
      "i_level_ict_solutions": "i-LEVEL ICT Solutions, Veldhoven - Implementatie en onderhoud van netwerkinfrastructuur, gericht op beveiligingsverbeteringen en cloudoplossingen.",
      "zit_intern": "ZIT Stagiair",
      "maxima_medical_center": "Máxima Medisch Centrum, Veldhoven - Beheer van IT en netwerkinfrastructuur in de gezondheidszorg.",
      "delivery_driver": "Bezorger",
      "dominos": "Domino's, Eindhoven - Parttime werk naast studie",
      "newspaper_delivery": "Krantenbezorger",
      "groot_eindhoven": "Groot Eindhoven - Eerste werkervaring",
      "services.title": "Wat ik doe",
      "services.cybersecurity.title": "Cybersecurity",
      "services.cybersecurity.description": "Implementatie en beheer van beveiligingsmaatregelen om systemen, netwerken en gegevens te beschermen.",
      "exp1_title": "Sales Medewerker",
      "exp1_company": "IKEA",
      "exp1_period": "Jul 2025 - Heden",
      "exp1_desc": "Klantenservice en verkoopondersteuning",
      "exp2_title": "Stagiair Automatisering",
      "exp2_company": "Van Boxtel",
      "exp2_period": "Sep 2024 - Jan 2026",
      "exp2_desc": "Stage automatiseringsproject gericht op systeemoptimalisatie en procesautomatisering",
      "exp3_title": "IT Stagiair",
      "exp3_company": "i-LEVEL ICT Solutions, Veldhoven",
      "exp3_period": "2022 - 2023",
      "exp3_desc": "Implementatie en onderhoud van netwerkinfrastructuur, gericht op beveiligingsverbeteringen en cloudoplossingen",
      "exp4_title": "ZIT Stagiair",
      "exp4_company": "Máxima Medisch Centrum, Veldhoven",
      "exp4_period": "2021 - 2022",
      "exp4_desc": "Beheer van IT en netwerkinfrastructuur in de gezondheidszorg",
      "exp5_title": "Bezorger",
      "exp5_company": "Domino's, Eindhoven",
      "exp5_period": "2022 - 2023",
      "exp5_desc": "Parttime werk naast studie",
      "exp6_title": "Krantenbezorger",
      "exp6_company": "Groot Eindhoven",
      "exp6_period": "2014 - 2016",
      "exp6_desc": "Eerste werkervaring",
      "services.security.title": "Beveiliging",
      "services.security.description": "Implementatie van beveiligingsmaatregelen om systemen en gegevens te beschermen. Proactieve monitoring en incidentrespons.",
      "services.network_engineering.title": "Netwerk Engineering",
      "services.network_engineering.description": "Ontwerp, implementatie en beheer van complexe netwerkinfrastructuren. Focus op betrouwbaarheid en prestaties.",
      "pricing.title": "Mijn Prijzen",
      "pricing.get_started": "Begin Nu",
      "pricing.basic.title": "Basis",
      "pricing.basic.price": "€25/uur",
      "pricing.basic.feature1": "Netwerkproblemen oplossen",
      "pricing.basic.feature2": "Basisbeveiligingsaudit",
      "pricing.basic.feature3": "Cloudconsultatie",
      "pricing.premium.title": "Premium",
      "pricing.premium.price": "€40/uur",
      "pricing.premium.feature1": "Geavanceerd netwerkontwerp",
      "pricing.premium.feature2": "Uitgebreide beveiligingsimplementatie",
      "pricing.premium.feature3": "Cloudmigratie en -beheer",
      "pricing.ultimate.title": "Ultiem",
      "pricing.ultimate.price": "€60/uur",
      "pricing.ultimate.feature1": "Volledig netwerk- en beveiligingsbeheer",
      "pricing.ultimate.feature2": "DevOps en automatiseringsoplossingen",
      "pricing.ultimate.feature3": "24/7 ondersteuning",
      "Feedback": "Feedback",
      "leave_feedback": "Laat je feedback achter",
      "submit": "Versturen",
      "feedback_submitted_successfully": "Bedankt voor je feedback!",
      "error_submitting_feedback": "Fout bij verzenden feedback. Probeer opnieuw.",
      "This feature is currently under development": "Deze functie is momenteel in ontwikkeling",
      "experience_title": "Ervaring",
      "experience_subtitle": "Bekijk mijn professionele reis op",
      "view_profile": "Bekijk Mijn Profiel",
      "experience_description": "Klik op de LinkedIn link om mijn complete professionele ervaring, vaardigheden en aanbevelingen te zien.",
      "visit_linkedin": "Volledige Profiel op LinkedIn",
      "education": "Onderwijs",
      "work_experience": "Werkervaring",
      "testimonials_title": "Getuigenissen van Klanten",
      "blog_title": "Laatste Artikelen",
      "skills_title": "Vaardigheden & Expertise",
      "tech_stack_title": "Tech Stack",
      "certificates_title": "Diploma's & Certificaten",
      "footer_title": "Laten we Samenwerken",
      "footer_subtitle": "Heb je een project of vraag? Neem gerust contact op!",
      "quick_links": "Snelle Links",
      "social_media": "Sociale Media",
      "start_project": "Start een Project",
      "all_rights_reserved": "Alle rechten voorbehouden."
    }
  },
  es: {
    translation: {
      "home": "Inicio",
      "about": "Acerca de",
      "services": "Servicios",
      "resume": "Currículum",
      "portfolio": "Portafolio",
      "blog": "Blog",
      "contact": "Contacto",
      "settings": "Configuraciones",
      "dark_mode": "Modo Oscuro",
      "language": "Idioma",
      "extra_option": "Opción Extra",
      "current_language": "Idioma actual: {{language}}",
      "scroll_down": "Desplazar hacia abajo",
      "contact_me": "Contáctame",
      "hello": "soy Bram! Un estudiante de TI apasionado por las redes, DevOps y la ciberseguridad.",
      "about_me": "Acerca de mí",
      "experience": "Experiencia",
      "recent_works": "Trabajos Recientes",
      "name": "Nombre",
      "email": "Correo electrónico",
      "message": "Mensaje",
      "send_message": "Enviar mensaje",
      "download_cv": "Descargar CV",
      "security": "Seguridad",
      "cloud_engineering": "Ingeniería en la Nube",
      "network_engineering": "Ingeniería de Redes",
      "job_title": "Título del Trabajo",
      "company_name": "Nombre de la Empresa",
      "job_description": "Descripción del Trabajo",
      "project_title": "Título del Proyecto",
      "project_description": "Descripción del Proyecto",
      "about_description": "Soy Bram Platier, un apasionado Ingeniero de Redes de Eindhoven, Países Bajos. Con experiencia en ciberseguridad, soluciones en la nube e infraestructura de redes, me encanta convertir desafíos técnicos complejos en soluciones elegantes. Actualmente enfocado en prácticas DevOps y tecnologías nativas de la nube para construir sistemas robustos y escalables.",
      "contact_details": "¿No te gustan los formularios? Envíame un correo electrónico. 👋",
      "message_sent": "¡Tu mensaje ha sido enviado!",
      "everything": "Todo",
      "view_project": "Ver proyecto",
      "websites": "Sitios Web",
      "cloud": "Nube",
      "devops": "DevOps",
      "automation": "Automatización",
  "containerization": "Contenerización",
      "servers_not_on_fire": "Servidores No en Llamas",
      "cups_of_tea": "1,000+ Tazas de té Consumidas",
      "happy_clients": "42 Clientes Felices",
      "awards_won": "0 Premios Ganados :(",
      "it_intern": "Practicante de TI",
      "i_level_ict_solutions": "i-LEVEL ICT Solutions, Veldhoven - Implementación y mantenimiento de infraestructura de red, enfocado en mejoras de seguridad y soluciones en la nube.",
      "zit_intern": "Practicante de ZIT",
      "maxima_medical_center": "Máxima Medisch Centrum, Veldhoven - Gestión de TI e infraestructura de red en el sector salud.",
      "delivery_driver": "Repartidor",
      "dominos": "Domino's, Eindhoven - Trabajo a tiempo parcial junto con los estudios",
      "newspaper_delivery": "Repartidor de Periódicos",
      "groot_eindhoven": "Groot Eindhoven - Primera experiencia laboral",
      "services.title": "Lo que hago",
      "services.cybersecurity.title": "Ciberseguridad",
      "services.cybersecurity.description": "Implementación y gestión de medidas de seguridad para proteger sistemas, redes y datos.",
      "exp1_title": "Empleado de Ventas",
      "exp1_company": "IKEA",
      "exp1_period": "Jul 2025 - Presente",
      "exp1_desc": "Servicio al cliente y apoyo a ventas",
      "exp2_title": "Pasante de Automatización",
      "exp2_company": "Van Boxtel",
      "exp2_period": "Sep 2024 - Ene 2026",
      "exp2_desc": "Pasantía en proyecto de automatización enfocado en optimización de sistemas",
      "exp3_title": "Pasante de TI",
      "exp3_company": "i-LEVEL ICT Solutions, Veldhoven",
      "exp3_period": "2022 - 2023",
      "exp3_desc": "Implementación y mantenimiento de infraestructura de red",
      "exp4_title": "Pasante ZIT",
      "exp4_company": "Máxima Medisch Centrum, Veldhoven",
      "exp4_period": "2021 - 2022",
      "exp4_desc": "Gestión de TI e infraestructura de red en salud",
      "exp5_title": "Repartidor",
      "exp5_company": "Domino's, Eindhoven",
      "exp5_period": "2022 - 2023",
      "exp5_desc": "Trabajo a tiempo parcial junto con los estudios",
      "exp6_title": "Repartidor de Periódicos",
      "exp6_company": "Groot Eindhoven",
      "exp6_period": "2014 - 2016",
      "exp6_desc": "Primera experiencia laboral",
      "services.security.title": "Seguridad",
      "services.security.description": "Implementación de medidas de seguridad para proteger sistemas y datos. Monitoreo proactivo y respuesta a incidentes.",
      "services.network_engineering.title": "Ingeniería de Redes",
      "services.network_engineering.description": "Diseño, implementación y gestión de infraestructuras de red complejas. Foco en confiabilidad y rendimiento.",
      "pricing.title": "Mis Precios",
      "pricing.get_started": "Empezar",
      "pricing.basic.title": "Básico",
      "pricing.basic.price": "€25/hora",
      "pricing.basic.feature1": "Solución de problemas de red",
      "pricing.basic.feature2": "Auditoría de seguridad básica",
      "pricing.basic.feature3": "Consulta en la nube",
      "pricing.premium.title": "Premium",
      "pricing.premium.price": "€40/hora",
      "pricing.premium.feature1": "Diseño de red avanzado",
      "pricing.premium.feature2": "Implementación de seguridad completa",
      "pricing.premium.feature3": "Migración y gestión de la nube",
      "pricing.ultimate.title": "Ultimate",
      "pricing.ultimate.price": "€60/hora",
      "pricing.ultimate.feature1": "Gestión completa de red y seguridad",
      "pricing.ultimate.feature2": "Soluciones DevOps y de automatización",
      "pricing.ultimate.feature3": "Soporte 24/7",
      "Feedback": "Retroalimentación",
      "leave_feedback": "Deja tu retroalimentación",
      "submit": "Enviar",
      "feedback_submitted_successfully": "¡Gracias por tu retroalimentación!",
      "error_submitting_feedback": "Error al enviar retroalimentación. Intenta de nuevo.",
      "This feature is currently under development": "Esta característica está actualmente en desarrollo",
      "experience_title": "Experiencia",
      "experience_subtitle": "Consulta mi trayectoria profesional en",
      "view_profile": "Ver Mi Perfil",
      "experience_description": "Haz clic en el enlace de LinkedIn para ver mi experiencia profesional completa, habilidades y recomendaciones.",
      "visit_linkedin": "Ver Perfil Completo en LinkedIn",
      "education": "Educación",
      "work_experience": "Experiencia Laboral",
      "testimonials_title": "Testimonios de Clientes",
      "blog_title": "Últimos Artículos",
      "skills_title": "Habilidades y Experiencia",
      "tech_stack_title": "Stack Tecnológico",
      "footer_title": "Trabajemos Juntos",
      "footer_subtitle": "¿Tienes un proyecto o una pregunta? ¡Contáctame!",
      "quick_links": "Enlaces Rápidos",
      "social_media": "Redes Sociales",
      "start_project": "Iniciar un Proyecto",
      "all_rights_reserved": "Todos los derechos reservados."
    }
  },
  fr: {
    translation: {
      "home": "Accueil",
      "about": "À propos",
      "services": "Services",
      "resume": "CV",
      "portfolio": "Portfolio",
      "blog": "Blog",
      "contact": "Contact",
      "settings": "Paramètres",
      "dark_mode": "Mode Sombre",
      "language": "Langue",
      "extra_option": "Option Supplémentaire",
      "current_language": "Langue actuelle: {{language}}",
      "scroll_down": "Faire défiler vers le bas",
      "contact_me": "Contactez-moi",
      "hello": "je suis Bram ! Un étudiant en informatique passionné par les réseaux, DevOps et la cybersécurité.",
      "about_me": "À propos de moi",
      "experience": "Expérience",
      "recent_works": "Travaux Récents",
      "name": "Nom",
      "email": "E-mail",
      "message": "Message",
      "send_message": "Envoyer le message",
      "download_cv": "Télécharger le CV",
      "security": "Sécurité",
      "cloud_engineering": "Ingénierie Cloud",
      "network_engineering": "Ingénierie Réseau",
      "job_title": "Titre du Poste",
      "company_name": "Nom de l'Entreprise",
      "job_description": "Description du Poste",
      "project_title": "Titre du Projet",
      "project_description": "Description du Projet",
      "about_description": "Je suis Bram Platier, un ingénieur réseau passionné d'Eindhoven, Pays-Bas. Avec une expertise en cybersécurité, solutions cloud et infrastructure réseau, j'aime transformer des défis techniques complexes en solutions élégantes. Actuellement concentré sur les pratiques DevOps et les technologies cloud-native pour construire des systèmes robustes et évolutifs.",
      "contact_details": "Vous n'aimez pas les formulaires ? Envoyez-moi un e-mail. 👋",
      "message_sent": "Votre message a été envoyé !",
      "everything": "Tout",
      "view_project": "Voir le projet",
      "websites": "Sites Web",
      "cloud": "Cloud",
      "devops": "DevOps",
      "automation": "Automatisation",
  "containerization": "Conteneurisation",
      "servers_not_on_fire": "Serveurs Pas en Feu",
      "cups_of_tea": "1,000+ Tasses de thé Consommées",
      "happy_clients": "42 Clients Satisfaits",
      "awards_won": "0 Prix Gagnés :(",
      "it_intern": "Stagiaire IT",
      "i_level_ict_solutions": "i-LEVEL ICT Solutions, Veldhoven - Mise en œuvre et maintenance de l'infrastructure réseau, axée sur les améliorations de sécurité et les solutions cloud.",
      "zit_intern": "Stagiaire ZIT",
      "maxima_medical_center": "Máxima Medisch Centrum, Veldhoven - Gestion de l'infrastructure IT et réseau dans le secteur de la santé.",
      "delivery_driver": "Livreur",
      "dominos": "Domino's, Eindhoven - Travail à temps partiel en parallèle des études",
      "newspaper_delivery": "Livreur de Journaux",
      "groot_eindhoven": "Groot Eindhoven - Première expérience professionnelle",
      "services.title": "Ce que je fais",
      "services.cybersecurity.title": "Cybersécurité",
      "services.cybersecurity.description": "Mise en œuvre et gestion de mesures de sécurité pour protéger les systèmes, les réseaux et les données.",
      "exp1_title": "Employé de Vente",
      "exp1_company": "IKEA",
      "exp1_period": "Juil 2025 - Présent",
      "exp1_desc": "Service client et support aux ventes",
      "exp2_title": "Stagiaire en Automatisation",
      "exp2_company": "Van Boxtel",
      "exp2_period": "Sep 2024 - Jan 2026",
      "exp2_desc": "Stage en projet d'automatisation axé sur l'optimisation des systèmes",
      "exp3_title": "Stagiaire IT",
      "exp3_company": "i-LEVEL ICT Solutions, Veldhoven",
      "exp3_period": "2022 - 2023",
      "exp3_desc": "Mise en œuvre et maintenance de l'infrastructure réseau",
      "exp4_title": "Stagiaire ZIT",
      "exp4_company": "Máxima Medisch Centrum, Veldhoven",
      "exp4_period": "2021 - 2022",
      "exp4_desc": "Gestion de l'infrastructure IT et réseau dans la santé",
      "exp5_title": "Livreur",
      "exp5_company": "Domino's, Eindhoven",
      "exp5_period": "2022 - 2023",
      "exp5_desc": "Travail à temps partiel en parallèle des études",
      "exp6_title": "Livreur de Journaux",
      "exp6_company": "Groot Eindhoven",
      "exp6_period": "2014 - 2016",
      "exp6_desc": "Première expérience professionnelle",
      "services.security.title": "Sécurité",
      "services.security.description": "Mise en œuvre de mesures de sécurité pour protéger les systèmes et les données. Surveillance proactive et réponse aux incidents.",
      "services.network_engineering.title": "Ingénierie Réseau",
      "services.network_engineering.description": "Conception, mise en œuvre et gestion d'infrastructures réseau complexes. Accent sur la fiabilité et les performances.",
      "pricing.title": "Mes Tarifs",
      "pricing.get_started": "Commencer",
      "pricing.basic.title": "Basique",
      "pricing.basic.price": "€25/heure",
      "pricing.basic.feature1": "Dépannage réseau",
      "pricing.basic.feature2": "Audit de sécurité de base",
      "pricing.basic.feature3": "Consultation cloud",
      "pricing.premium.title": "Premium",
      "pricing.premium.price": "€40/heure",
      "pricing.premium.feature1": "Conception de réseau avancée",
      "pricing.premium.feature2": "Mise en œuvre complète de la sécurité",
      "pricing.premium.feature3": "Migration et gestion du cloud",
      "pricing.ultimate.title": "Ultime",
      "pricing.ultimate.price": "€60/heure",
      "pricing.ultimate.feature1": "Gestion complète du réseau et de la sécurité",
      "pricing.ultimate.feature2": "Solutions DevOps et d'automatisation",
      "pricing.ultimate.feature3": "Support 24/7",
      "Feedback": "Commentaires",
      "leave_feedback": "Laissez vos commentaires",
      "submit": "Soumettre",
      "feedback_submitted_successfully": "Merci pour vos commentaires !",
      "error_submitting_feedback": "Erreur lors de l'envoi des commentaires. Veuillez réessayer.",
      "This feature is currently under development": "Cette fonctionnalité est actuellement en développement",
      "experience_title": "Expérience",
      "experience_subtitle": "Consultez mon parcours professionnel sur",
      "view_profile": "Voir Mon Profil",
      "experience_description": "Cliquez sur le lien LinkedIn pour voir mon expérience professionnelle complète, mes compétences et mes recommandations.",
      "visit_linkedin": "Voir le Profil Complet sur LinkedIn",
      "education": "Éducation",
      "work_experience": "Expérience Professionnelle",
      "testimonials_title": "Témoignages de Clients",
      "blog_title": "Derniers Articles",
      "skills_title": "Compétences et Expertise",
      "tech_stack_title": "Stack Technologique",
      "footer_title": "Travaillons Ensemble",
      "footer_subtitle": "Vous avez un projet ou une question ? N'hésitez pas à me contacter !",
      "quick_links": "Liens Rapides",
      "social_media": "Réseaux Sociaux",
      "start_project": "Démarrer un Projet",
      "all_rights_reserved": "Tous les droits réservés."
    }
  },
  zh: {
    translation: {
      "home": "首页",
      "about": "关于",
      "services": "服务",
      "resume": "简历",
      "portfolio": "作品集",
      "blog": "博客",
      "contact": "联系",
      "settings": "设置",
      "dark_mode": "黑暗模式",
      "language": "语言",
      "extra_option": "额外选项",
      "current_language": "当前语言: {{language}}",
      "scroll_down": "向下滚动",
      "contact_me": "联系我",
      "hello": "我是Bram！一名对网络、DevOps和网络安全充满热情的IT学生。",
      "about_me": "关于我",
      "experience": "经验",
      "recent_works": "最近的作品",
      "name": "名字",
      "email": "电子邮件",
      "message": "信息",
      "send_message": "发送信息",
      "download_cv": "下载简历",
      "security": "安全",
      "cloud_engineering": "云工程",
      "network_engineering": "网络工程",
      "job_title": "职位名称",
      "company_name": "公司名称",
      "job_description": "职位描述",
      "project_title": "项目名称",
      "project_description": "项目描述",
      "about_description": "我是Bram Platier，一名来自荷兰埃因霍温的热情网络工程师。拥有网络安全、云解决方案和网络基础设施方面的专业知识，我喜欢将复杂的技术挑战转化为优雅的解决方案。目前专注于DevOps实践和云原生技术，以构建强大、可扩展的系统。",
      "contact_details": "不喜欢表格？给我发电子邮件。 👋",
      "message_sent": "您的信息已发送！",
      "everything": "所有",
      "view_project": "查看项目",
      "websites": "网站",
      "cloud": "云",
      "devops": "DevOps",
      "automation": "自动化",
  "containerization": "容器化",
      "servers_not_on_fire": "服务器未着火",
      "cups_of_tea": "1,000+ 杯茶消耗",
      "happy_clients": "42 位满意的客户",
      "awards_won": "0 个奖项获得 :(",
      "it_intern": "IT 实习生",
      "i_level_ict_solutions": "i-LEVEL ICT Solutions，Veldhoven - 实施和维护网络基础设施，专注于安全改进和云解决方案。",
      "zit_intern": "ZIT 实习生",
      "maxima_medical_center": "Máxima Medisch Centrum，Veldhoven - 医疗IT和网络基础设施管理。",
      "delivery_driver": "送货员",
      "dominos": "Domino's，埃因霍温 - 兼职工作与学习并行",
      "newspaper_delivery": "报纸投递员",
      "groot_eindhoven": "Groot Eindhoven - 第一份工作经验",
      "services.title": "我做什么",
      "services.cybersecurity.title": "网络安全",
      "services.cybersecurity.description": "实施和管理安全措施以保护系统、网络和数据。",
      "exp1_title": "销售员工",
      "exp1_company": "宜家",
      "exp1_period": "2025年7月 - 至今",
      "exp1_desc": "客户服务和销售支持",
      "exp2_title": "自动化实习生",
      "exp2_company": "Van Boxtel",
      "exp2_period": "2024年9月 - 2026年1月",
      "exp2_desc": "专注于系统优化和流程自动化的自动化项目实习",
      "exp3_title": "IT 实习生",
      "exp3_company": "i-LEVEL ICT Solutions, Veldhoven",
      "exp3_period": "2022 - 2023",
      "exp3_desc": "实施和维护网络基础设施",
      "exp4_title": "ZIT 实习生",
      "exp4_company": "Máxima Medisch Centrum, Veldhoven",
      "exp4_period": "2021 - 2022",
      "exp4_desc": "医疗IT和网络基础设施管理",
      "exp5_title": "送货员",
      "exp5_company": "达美乐, 埃因霍温",
      "exp5_period": "2022 - 2023",
      "exp5_desc": "兼职工作与学习并行",
      "exp6_title": "报纸投递员",
      "exp6_company": "Groot Eindhoven",
      "exp6_period": "2014 - 2016",
      "exp6_desc": "第一份工作经验",
      "services.security.title": "安全",
      "services.security.description": "实施安全措施以保护系统和数据。主动监控和事件响应。",
      "services.network_engineering.title": "网络工程",
      "services.network_engineering.description": "设计、实施和管理复杂的网络基础设施。注重可靠性和性能。",
      "pricing.title": "我的价格",
      "pricing.get_started": "开始",
      "pricing.basic.title": "基本",
      "pricing.basic.price": "€25/小时",
      "pricing.basic.feature1": "网络故障排除",
      "pricing.basic.feature2": "基本安全审计",
      "pricing.basic.feature3": "云咨询",
      "pricing.premium.title": "保费",
      "pricing.premium.price": "€40/小时",
      "pricing.premium.feature1": "高级网络设计",
      "pricing.premium.feature2": "全面的安全实施",
      "pricing.premium.feature3": "云迁移和管理",
      "pricing.ultimate.title": "最终",
      "pricing.ultimate.price": "€60/小时",
      "pricing.ultimate.feature1": "完整的网络和安全管理",
      "pricing.ultimate.feature2": "DevOps 和自动化解决方案",
      "pricing.ultimate.feature3": "24/7 支持",
      "Feedback": "反馈",
      "leave_feedback": "留下您的反馈",
      "submit": "提交",
      "feedback_submitted_successfully": "感谢您的反馈！",
      "error_submitting_feedback": "提交反馈时出错。请重试。",
      "This feature is currently under development": "此功能正在开发中",
      "experience_title": "经验",
      "experience_subtitle": "在上查看我的专业之旅",
      "view_profile": "查看我的资料",
      "experience_description": "单击LinkedIn链接查看我的完整专业经验、技能和推荐。",
      "visit_linkedin": "在LinkedIn上查看完整个人资料",
      "education": "教育",
      "work_experience": "工作经验",
      "testimonials_title": "客户评价",
      "blog_title": "最新文章",
      "skills_title": "技能与专业知识",
      "tech_stack_title": "技术栈",
      "footer_title": "让我们一起合作",
      "footer_subtitle": "有项目或问题吗？请随时联系！",
      "quick_links": "快速链接",
      "social_media": "社交媒体",
      "start_project": "开始一个项目",
      "all_rights_reserved": "上述中文流清。"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
